// RolesLegend
// -----------
// Plain-language key for the three account roles and what each can do.
// Rendered inside a <HelpTip> on the Users page so an admin choosing a role —
// or a user wondering what their own badge means — sees the capabilities in
// context. Covers Account Owner too, which has no "change role" button of its
// own (ownership moves via transfer, not the role picker).
//
// Copy is sourced from the shared *_ROLE_DESCRIPTION constants so this legend
// and the change-role buttons can't disagree.

import React from "react";
import {
  ADMIN_DISPLAY_VALUE,
  ADMIN_ROLE_DESCRIPTION,
  CLIENT_OWNER_DISPLAY_VALUE,
  CLIENT_OWNER_ROLE_DESCRIPTION,
  PENTESTER_DISPLAY_VALUE,
  PENTESTER_ROLE_DESCRIPTION,
} from "@/constants/definitions";

interface RoleRow {
  name: string;
  description: string;
}

// Ordered least → most privileged so the escalation reads naturally.
const ROLE_ROWS: RoleRow[] = [
  { name: PENTESTER_DISPLAY_VALUE, description: PENTESTER_ROLE_DESCRIPTION },
  { name: ADMIN_DISPLAY_VALUE, description: ADMIN_ROLE_DESCRIPTION },
  { name: CLIENT_OWNER_DISPLAY_VALUE, description: CLIENT_OWNER_ROLE_DESCRIPTION },
];

export default function RolesLegend() {
  return (
    <div className="flex flex-col gap-2">
      <p className="font-medium text-white">Account roles</p>
      {ROLE_ROWS.map((role) => (
        <div key={role.name} className="flex flex-col">
          <span className="font-medium text-white">{role.name}</span>
          <span className="text-gray-300">{role.description}</span>
        </div>
      ))}
    </div>
  );
}
